import {useApiQuery} from 'src/hooks/useApiQuery';
import type {DashboardDetail} from 'src/types/byod';
import {BYOD_API_BASE as BASE} from 'src/components/analytics-genesis/byod/api';
import {byodQueryDefaults} from 'src/components/analytics-genesis/byod/api/error-handling';


export function useLoadDashboard(dashboardId: string | null) {
  return useApiQuery<DashboardDetail>(
    dashboardId
      ? {pathname: `${BASE}/dashboards/${encodeURIComponent(dashboardId)}`}
      : null,
    {
      queryOptions: {
        ...byodQueryDefaults,
        queryKey: ['byod-dashboard', dashboardId],
        enabled: Boolean(dashboardId),
        // Always fetch fresh — prevents seeding store with stale cached data
        // when navigating between dashboards. The store is the source of truth
        // during a session; caching would fight onEnter's reset().
        staleTime: 0,
        gcTime: 0,
        // Don't refetch on window focus — builder store is source of truth
        // for the session; background refetches would not re-seed anyway
        // but this avoids unnecessary network calls.
        refetchOnWindowFocus: false,
      },
    },
  );
}
